/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';

/**
 * 
 * @export
 * @interface InternalApiScreeningClearanceRulesAnalysis
 */
export interface InternalApiScreeningClearanceRulesAnalysis {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningClearanceRulesAnalysis
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRulesAnalysis
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRulesAnalysis
     */
    description?: string;
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiScreeningClearanceRulesAnalysis
     */
    entityType: InternalApiEntityType;
}



/**
 * Check if a given object implements the InternalApiScreeningClearanceRulesAnalysis interface.
 */
export function instanceOfInternalApiScreeningClearanceRulesAnalysis(value: object): value is InternalApiScreeningClearanceRulesAnalysis {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    return true;
}

export function InternalApiScreeningClearanceRulesAnalysisFromJSON(json: any): InternalApiScreeningClearanceRulesAnalysis {
    return InternalApiScreeningClearanceRulesAnalysisFromJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRulesAnalysisFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningClearanceRulesAnalysis {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
    };
}

export function InternalApiScreeningClearanceRulesAnalysisToJSON(json: any): InternalApiScreeningClearanceRulesAnalysis {
    return InternalApiScreeningClearanceRulesAnalysisToJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRulesAnalysisToJSONTyped(value?: InternalApiScreeningClearanceRulesAnalysis | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
    };
}

